<div id="mapi"></div>
<!--<pre id='info'></pre>-->

<div id="map-overlay" class="map-overlay"></div>


<div id="popupi" >
  <!--Habilitar CERRAR PopUP    -->
  <!--  -->
  <div *ngIf="infoElementoPuntos">
    <p class="text-center">{{infoElementoPuntos.nombre_manifestacion}}</p>
    <img src="assets/img/secciones/inmaterial/{{infoElementoPuntos.codregistro}}.jpg" class="img-fluid" />
    <!--<p>{{infoElementoPuntos.codregistro}}</p>-->
    <button class="btn btn-primary btn-sm btn-01-color-gchc btn-block"
      (click)="cargarCatFichaInmaterialPorCodregistro(infoElementoPuntos.codregistro)"><i class="fa fa-eye mx-1"
        aria-hidden="true"></i> ver más</button>
    
  </div>
</div>

